<template>
  <div class="popup_body">
    <div class="popup_body_div">
      <div class="popup_icon_one" @click="alterPassClick">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>修改密码</p>
      </div>
      <!-- <div class="popup_icon_one">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>功能操作</p>
      </div>
      <div class="popup_icon_one">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>功能操作</p>
      </div>
      <div class="popup_icon_one">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>功能操作</p>
      </div>
      <div class="popup_icon_one">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>功能操作</p>
      </div>
      <div class="popup_icon_one">
        <div class="popup_img">
          <i class="iconfont icon-jiekou"></i>
        </div>
        <p>功能操作</p>
      </div> -->
    </div>

    <div>
      <change-password-popup
        ref="password"
        @closePopup="closePopup"
      ></change-password-popup>
    </div>
  </div>
</template>

<script>
import changePasswordPopup from "./change-password-popup.vue";
export default {
  components: {
    changePasswordPopup,
  },
  methods: {
    alterPassClick() {
      this.$refs.password.alterPassClick();
      this.$emit("closePopup", true);
    },
    closePopup() {
      this.$emit("closePopup", false);
    },
  },
};
</script>

<style scoped>
.popup_body {
  width: 55rem;
  height: 34rem;
  background-color: #011c24;
  border: 1px solid #1f788e;
  box-shadow: 0rem 0rem 2rem 0.1rem #1f788e inset;
}
.popup_body_div {
  margin: 3.7rem 4rem;
  height: 26rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 3rem;
  grid-row-gap: 0rem;
  /* overflow-y: auto; */
  overflow: hidden;
  /* border: 1px solid red; */
}
.popup_icon_one {
  /* width: 7rem; */
  height: 9rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* font-size: 1.3rem; */
  /* border: 1px solid blue; */
}
.popup_icon_one p {
  color: #65d3ef;
}
.popup_img {
  width: 6rem;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #13a1c5;
  color: rgb(20, 195, 239);
  /* box-shadow: 0rem 0rem 2rem 0.1rem #1f788e; */
}
.popup_img:hover {
  cursor: pointer;
  background-color: rgba(9, 192, 237, 0.2);
  color: rgb(255, 255, 255);
}
.popup_img i {
  font-size: 4rem;
}
</style>
